import { ConfigurationService } from '../configuration-service/index.js';
import { createURL } from '../http-service/http-service-utils.js';
import { HttpHeader, MediaType } from '../http-service/index.js';
function formatRequestBody(parameters) {
    const parametersReducer = (accumulator, key) => {
        accumulator.append(key, parameters[key]);
        return accumulator;
    };
    return Object.keys(parameters).reduce(parametersReducer, new URLSearchParams()).toString();
}
function request(endpoint, parameters, headers = new Headers()) {
    const { method = 'POST', url } = endpoint;
    const body = formatRequestBody(parameters);
    headers.append(HttpHeader.ACCEPT, MediaType.APPLICATION_JSON);
    headers.append(HttpHeader.CONTENT_TYPE, MediaType.APPLICATION_FORM_URLENCODED);
    return fetch(createURL(url, ConfigurationService.getBaseURL()).toString(), {
        body,
        headers,
        method,
    });
}
export { formatRequestBody, request, };
//# sourceMappingURL=request.js.map